import { connect, mapProps } from '@formily/react'
import { Slider as UISlider } from '@/components/ui/slider'

export interface FormilySliderProps {
  value?: number | number[]
  onChange?: (value: number | number[]) => void
  min?: number
  max?: number
  step?: number
  className?: string
  disabled?: boolean
}

const InternalSlider = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  className,
  disabled,
  ...props
}: FormilySliderProps) => {
  const normalizedValue = Array.isArray(value) ? value : [value ?? 0]

  return (
    <UISlider
      value={normalizedValue}
      onValueChange={(newValue) => {
        if (onChange) {
          onChange(newValue.length === 1 ? newValue[0] : newValue)
        }
      }}
      min={min}
      max={max}
      step={step}
      className={className}
      disabled={disabled}
      {...props}
    />
  )
}

export const FormilySlider = connect(
  InternalSlider,
  mapProps((props) => ({
    ...props,
    value: props.value || 0,
  })),
)
